import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import DateColumn from "@isceco/widget-library2/basic-elements/List/column/DateColumn.js";

export default class VNBDashboardColumns {

  static getColumns() {
    return [
      VNBDashboardColumns.EMPFAENGER_COLUMN(),
      VNBDashboardColumns.TOKEN_COLUMN(),
      VNBDashboardColumns.EINLADUNGSDATUM_COLUMN(),
      VNBDashboardColumns.GUELTIG_BIS_COLUMN(),
      VNBDashboardColumns.STATUS_COLUMN(),
    ]
  }

  static EMPFAENGER_COLUMN() {
    return new StringColumn({
      key: 'empfaenger',
      text: 'dashboard.vnb.filter.empfaenger',
      sortable: true,
    })
  }

  static TOKEN_COLUMN() {
    return new StringColumn({
      key: 'token',
      text: 'dashboard.vnb.filter.ott',
    })
  }

  static EINLADUNGSDATUM_COLUMN() {
    return new DateColumn({
      key: 'createdAt',
      text: 'dashboard.vnb.filter.einladung',
      sortable: true
    })
  }

  static GUELTIG_BIS_COLUMN() {
    return new DateColumn({
      key: 'validUntil',
      text: 'dashboard.vnb.filter.date',
      sortable: true
    })
  }

  static STATUS_COLUMN() {
    return new StringColumn({
      key: 'einladungStatus',
      text: 'dashboard.vnb.filter.status',
      translate: true
    })
  }
}
